/**
 * InvoiceAgentPage — osobny ekran Agenta Faktur (Vendor Group Architecture).
 *
 * Reusuje istniejący komponent `InvoiceAgentTab` bez przepisywania logiki.
 * Dodaje breadcrumb / nagłówek + przycisk powrotu do listy faktur. Wzorzec
 * skopiowany 1:1 z `BankAgentPage`.
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import InvoiceAgentTab from "./InvoiceAgentTab";
import { usePageContainer } from "@/hooks/usePageContainer";

const InvoiceAgentPage = () => {
  const navigate = useNavigate();
  // Pakiet 1: Agent Faktur pokazuje gęste listy — szerszy kontener.
  usePageContainer("wide");

  return (
    <div data-testid="invoice-agent-page">
      <div className="mb-4 flex items-center gap-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/invoices")}
          data-testid="invoice-agent-back-btn"
          className="text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-4 h-4 mr-1.5" />
          Wróć do Faktur
        </Button>
      </div>
      <header className="mb-5 flex items-start gap-3">
        <div className="p-2 bg-indigo-50 rounded-md">
          <Bot className="w-6 h-6 text-indigo-700" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">Agent Faktur</h1>
          <p className="text-sm text-gray-600 mt-1">
            Analiza grup faktur per kontrahent (NIP) i budowa profili strukturalnych.
            Każdy kontrahent = osobny prompt = osobny profil.
          </p>
        </div>
      </header>
      <InvoiceAgentTab />
    </div>
  );
};

export default InvoiceAgentPage;
